import { createSelector } from '@reduxjs/toolkit';
export const tableUserFiltersSelector = (state) => state.tablesFilters;
export const tableFiltersDataSelector = createSelector(tableUserFiltersSelector, (prefs) => prefs.inputFilters);
export const tableFiltersForQueriesSelector = createSelector(tableUserFiltersSelector, (prefs) => prefs.filtersForQueries);
